type PoweredByProps = {
  /** Panel footer inside the open chat, or watermark under the closed launcher. */
  variant?: 'panel' | 'launcher';
};

export function PoweredBy({ variant = 'panel' }: PoweredByProps) {
  const isLauncher = variant === 'launcher';

  return (
    <footer
      className={isLauncher ? 'rw-launcher-watermark' : 'rw-powered-by'}
      aria-label="Widget branding"
    >
      {isLauncher ? (
        <a
          className="rw-launcher-watermark-link"
          href="https://www.revokonek.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Powered by Revokonek
        </a>
      ) : (
        <>
          <span className="rw-powered-by-prefix">Powered by </span>
          <a
            className="rw-powered-by-link"
            href="https://www.revokonek.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Revokonek <span aria-hidden="true">↗</span>
          </a>
        </>
      )}
    </footer>
  );
}
